import { ServicesContainer } from '@/services';
import { LoginCompleteEvent } from '@/services/analytics/events/login-complete-event';
import { AnalyticsEventType } from '@/services/analytics/platforms/adobe-analytics/models';
import { AppState } from '@/store';
import { Store } from 'vuex';
import { AdobeBaseEvent } from './adobe-base-event';

export class AdobeLoginCompleteEvent extends AdobeBaseEvent {
  event = AnalyticsEventType.LoginComplete;

  constructor(event: LoginCompleteEvent, store: Store<AppState>, services: ServicesContainer) {
    super(store, services);
    this.account.userID = store.state.customer.profile?.customerIdHash;
  }
}